
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class StageMembersDialog extends _Ext.EditorDialogBase<StageMembersRow> {
        protected getFormKey() { return StageMembersForm.formKey; } 
        protected getLocalTextPrefix() { return StageMembersRow.localTextPrefix; }
        protected getNameProperty() { return StageMembersRow.nameProperty; } 

        protected form = new StageMembersForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let options = super.get_ExtDialogOptions();
            options.AutoFitContentArea = false;
            return options;
        }

        constructor() {
            super();
        }
    }
}